module.exports = __webpack_public_path__ + "img/typeall.7e2bb823.png";